module.exports = __webpack_public_path__ + "img/winking_face.65eae97c.gif";